import Settings from "../../../components/Settings";
import {withRouter} from 'react-router';
const SettingsPage = () => {
    return <Settings />
}
export default withRouter(SettingsPage);
